module.exports = __webpack_public_path__ + "img/icon_investmezzanine_strong_01.983e344e.svg";